import React from 'react'

const KAMViewTabs = ({ viewMode, onViewModeChange }) => {
  const tabs = [
    { id: 'general', label: 'Ranking Ogólny', icon: 'fa-ranking-star' },
    { id: 'by-operator', label: 'Per Operator', icon: 'fa-tower-broadcast' },
    { id: 'per-kam', label: 'Per KAM', icon: 'fa-user-tag' }
  ]

  return (
    <div className="flex items-center border-b border-gray-200 mb-6">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => onViewModeChange(tab.id)}
          className={`flex items-center px-4 py-3 text-sm font-medium transition-colors ${
            viewMode === tab.id
              ? 'text-blue-600 border-b-2 border-blue-600 font-semibold'
              : 'text-gray-500 hover:text-gray-800'
          }`}
        >
          <i className={`fa-solid ${tab.icon} mr-2`}></i>
          {tab.label}
        </button>
      ))}
    </div>
  )
}

export default KAMViewTabs


